import React, { Component } from 'react'
import { connect } from 'react-redux'
import { ServiceExport as ServiceExport23 } from 'projects/flow-gui-access/views/2.3/core'
import { ServiceExport as ServiceExport24 } from 'projects/flow-gui-access/views/2.4/core'

class ServiceExport extends Component {

  render () {
    if (this.props.configReducer.endpoints.filter(endpoint => endpoint.name === 'accesses' && endpoint.version === '2.4').length !== 0) {
      return <ServiceExport24 {...this.props} />
    } else if (this.props.configReducer.endpoints.filter(endpoint => endpoint.name === 'accesses' && endpoint.version === '2.3').length !== 0) {
      return <ServiceExport23 {...this.props} />
    } else return false
  }
}
//eslint-disable-next-line
ServiceExport = connect(state => state)(ServiceExport)
export default ServiceExport



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/views/core/services.js